export function configToSlugMap(config) {
  if (config && typeof config === 'object') {
    if ('slugs' in config) {
      return config.slugs;
    }
    if ('pages' in config) {
      const pages = config.pages;
      return Object.fromEntries(pages.map(page => [page.tpaPageId, page.pageUriSEO]));
    }
  }
  return undefined;
}
//# sourceMappingURL=router-config.js.map